<template>
  <div>
    <v-row dense>
      <v-col cols="5">
        {{ leftLabel }}<br />
        <v-card class="overflow" tile>
          <v-list max-height="400" dense min-height="400" tile>
            <v-list-item-group v-if="!carrierId">
              <v-list-item>
                <v-list-item-content>
                  Selecione uma Operadora
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>

            <v-list-item-group v-if="isLoading">
              <v-list-item dense>
                <v-list-item-content>
                  <v-progress-linear indeterminate></v-progress-linear
                ></v-list-item-content>
              </v-list-item>
            </v-list-item-group>

            <v-list-item-group
              v-if="!isLoading && carrierId"
              multiple
              v-model="leftSelected"
              color="blue"
            >
              <draggable group="plans" :list="plans" :sort="false">
                <v-list-item
                  dense
                  v-for="(plan, i) in plans"
                  :key="i"
                  class="list-item"
                >
                  <v-list-item-icon class="item_icon_dense">
                    <v-icon small>fas fa-arrows-alt</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ `${plan.productCode}-${plan.description}` }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </draggable>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-col>

      <v-col cols="1">
        <v-container fluid fill-height>
          <v-layout column align-center justify-center>
            <v-btn
              small
              class="btn"
              :disabled="leftSelected.length == 0"
              @click="moveToRight"
            >
              <v-icon small>fas fa-angle-right</v-icon>
            </v-btn>
            <v-btn
              small
              class="btn"
              :disabled="plans.length == 0"
              @click="moveAllToRight"
            >
              <v-icon small>fas fa-angle-double-right</v-icon>
            </v-btn>
            <v-btn
              small
              class="btn"
              :disabled="selectedPlans.length == 0"
              @click="moveAllToLeft"
            >
              <v-icon small>fas fa-angle-double-left</v-icon>
            </v-btn>
            <v-btn
              small
              class="btn"
              :disabled="rightSelected.length == 0"
              @click="moveToLeft"
            >
              <v-icon small>fas fa-angle-left</v-icon>
            </v-btn>
          </v-layout>
        </v-container>
      </v-col>

      <v-col cols="5">
        <v-icon x-small class="icon-up">fas fa-caret-square-up</v-icon>&nbsp;
        <v-icon x-small class="icon-down">fas fa-caret-square-down</v-icon
        >&nbsp;&nbsp;&nbsp;&nbsp; {{ rightLabel }}<br />
        <v-card class="overflow" tile>
          <v-list max-height="400" dense min-height="400" tile>
            <v-list-item-group v-if="!carrierId">
              <v-list-item>
                <v-list-item-content>
                  Selecione uma Operadora
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>

            <v-list-item-group v-if="isLoading">
              <v-list-item dense>
                <v-list-item-content>
                  <v-progress-linear indeterminate></v-progress-linear
                ></v-list-item-content>
              </v-list-item>
            </v-list-item-group>

            <v-list-item-group
              v-if="!isLoading && carrierId"
              multiple
              v-model="rightSelected"
              color="blue"
            >
              <draggable
                group="plans"
                :list="selectedPlans"
                :sort="false"
                @change="log"
                :move="onMoveCallback"
                class="r-panel-draggable"
              >
                <v-list-item
                  dense
                  v-for="(selected, i) in selectedPlans"
                  :key="i"
                  class="list-item"
                >
                  <v-list-item-icon class="item_icon_dense">
                    <v-icon x-small>fas fa-arrows-alt</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-container class="px-0" fluid>
                        <v-btn
                          x-small
                          icon
                          class="btn-checkbox"
                          @click="selected.upGrade = !selected.upGrade"
                        >
                          <v-icon x-small title="Upgrade" class="icon-up">
                            fas
                            {{
                              selected.upGrade ? 'fa-check-square' : 'fa-square'
                            }}
                          </v-icon>
                        </v-btn>
                        <v-btn
                          x-small
                          icon
                          class="btn-checkbox"
                          @click="selected.downGrade = !selected.downGrade"
                        >
                          <v-icon x-small title="Downgrade" class="icon-down">
                            fas
                            {{
                              selected.downGrade
                                ? 'fa-check-square'
                                : 'fa-square'
                            }}
                          </v-icon>
                        </v-btn>
                        {{ `${selected.productCode}-${selected.description}` }}
                      </v-container>
                      <draggable
                        class="dragArea"
                        tag="div"
                        :list="selected.children"
                        :group="{name: 'plans'}"
                      >
                        <div v-for="el in selected.children" :key="el.id" class="sub-item">
                          {{ `${el.productCode}-${el.description}` }}
                        </div>
                      </draggable>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </draggable>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import draggable from 'vuedraggable';
import ProductService from '@/services/odoo/ProductService';
import PlanEquivalenceConfigurationService from '@/services/insurancepricing/PlanEquivalenceConfigurationService';

export default {
  components: {draggable},
  props: {
    leftLabel: {type: String, require: true},
    rightLabel: {type: String, require: true},
    carrierId: {type: String},
    equivalenceConfigurationId: {type: [Number, String], require: true},
  },

  data() {
    return {
      isLoading: false,
      plans: [],
      selectedPlans: [],
      leftSelected: [],
      rightSelected: [],
    };
  },
  watch: {
    carrierId: function (newVal, oldVal) {
      this.loadPlans();
    },
  },
  created() {
    this._productService = new ProductService();
    this._planEquicConfService = new PlanEquivalenceConfigurationService();
    this.loadPlans();
  },

  methods: { 
    log: function (evt) {
      this.$emit('update:selectedPlans', this.selectedPlans);
      this.$emit('update:userChage');
    },

    onMoveCallback(evt, originalEvent) {
      //Não permite criar como filho um elemento que já tem filhos
      if (evt.draggedContext.element.children.length) return false;
      return true;
    },

    loadPlans() {
      this.plans = [];
      if (this.carrierId) {
        this.isLoading = true;
        Promise.all([
          this._productService.findByCarrier(this.carrierId),
          this._planEquicConfService.findAllByParams({
            equivalenceCarrierId: this.carrierId,
            equivalenceConfigurationId: this.equivalenceConfigurationId,
            page: 0,
            sortBy: 'equivalentPlan.productCode',
            descending: false,
            size: 10000,
          }),
        ])
          .then((responses) => {
            //Converte a estrutura de dados enviada pelo servidor para o formato utilizado no FE
            const selectedPlans = responses[1].data.content.map((e) => {
              return {
                _id: e.id,
                id: e.equivalentPlan.id,
                carrierId: e.equivalentPlan.carrierId,
                carrierName: e.equivalentPlan.carrierName,
                productCode: e.equivalentPlan.productCode,
                description: e.equivalentPlan.description,
                downGrade: e.downGrade,
                upGrade: e.upGrade,
                children: e.inheritPlanEquivalenceConfigurations.map((f) => {
                  return {
                    _id: f.id,
                    id: f.plan.id,
                    carrierId: f.plan.carrierId,
                    carrierName: f.plan.carrierName,
                    productCode: f.plan.productCode,
                    description: f.plan.description,
                  };
                }),
              };
            });

            //Cria uma lista com os id selecionados, pais e filhos
            const selectedIds = selectedPlans.flatMap((e) => {
              return [e.id, ...e.children.map((f) => f.id)];
            });

            //Remove dos planos disponíveins os planos já selecionados
            const plans = responses[0].data
              .filter((o) => {
                return selectedIds.indexOf(o.id) == -1;
              }) // e inclui compos utilizados no FE
              .map((e) => {
                return {
                  ...e,
                  ...{children: [], downGrade: false, upGrade: false},
                };
              });
            this.plans = plans;
            this.selectedPlans = selectedPlans;
            this.$emit('update:selectedPlans', this.selectedPlans);
            this.isLoading = false;
          })
          .catch((error) => {
            console.log(error.response);
            this.isLoading = false;
          });
      }
    },

    _compareByProductCode(a, b) {
      if (a.productCode > b.productCode) return 1;
      if (a.productCode < b.productCode) return -1;
      return 0;
    },

    _moveTo(selected, origin, dest) {
      selected.forEach((n) => {
        dest.push(...[origin[n], ...origin[n].children]);
        origin[n].children = [];
      });
      selected.reverse().forEach((n) => origin.splice(n, 1));
      dest.sort(this._compareByProductCode);
      selected.splice(0, selected.length);
      this.$emit('update:userChage');
    },

    _moveAllTo(origin, dest) {
      origin.forEach((e) => {
        dest.push(...[e, ...e.children]);
        e.children = [];
      });
      dest.sort(this._compareByProductCode);
      origin.splice(0, origin.length);
      this.$emit('update:userChage');
    },

    moveToLeft() {
      this._moveTo(this.rightSelected, this.selectedPlans, this.plans);
    },

    moveAllToLeft() {
      this._moveAllTo(this.selectedPlans, this.plans);
    },

    moveToRight() {
      this._moveTo(this.leftSelected, this.plans, this.selectedPlans);
    },

    moveAllToRight() {
      this._moveAllTo(this.plans, this.selectedPlans);
    },
  },
};
</script>

<style scoped>
.overflow {
  overflow-y: auto;
}
.btn {
  margin-bottom: 20px;
}
.dragArea {
  min-height: 40px;
  outline: 1px dashed;
  background-color: var(--v-muted-base);
  margin-bottom: 8px;
  padding-top: 4px;
  padding-bottom: 4px;
}
.item_icon_dense {
  margin-right: 8px !important;
}
.btn-checkbox {
  width: auto !important;
}
.icon-up {
  color: var(--v-green-base);
}
.icon-down {
  color: var(--v-red-base);
}

.list-item {
  margin: 5px;
  border-radius: 4px;
  background: var(--v-muted-base);
}
.sub-item {
  background-color: var(--v-muted-base);
  margin:  0px 4px 4px 4px;
  padding: 4px 4px 4px 4px;
}
  
.r-panel-draggable {
  min-height: 100px;
  padding-bottom: 50px;
}
</style>
